import type { FilterFn } from '@tanstack/react-table'
import { IInvestmentStatus } from '~/@api/generated-api-types-account/Api'
import type { Investment } from '../_investment_types/investment.types'

export const minMaxFilter: FilterFn<Investment> = (
  row,
  columnId,
  filterValue
) => {
  const value = row.getValue(columnId)

  if (typeof value !== 'number' || !Array.isArray(filterValue)) {
    return true
  }

  return filterValue.length
    ? filterValue.some(
        ({ min = -Infinity, max = Infinity }) => value >= min && value <= max
      )
    : true
}

export function isInvestmentDelayedOrExtended(investment: Investment) {
  if (
    investment.status === IInvestmentStatus.Invested ||
    investment.status === IInvestmentStatus.Delayed ||
    investment.status === IInvestmentStatus.Extended
  ) {
    const isExtended = investment.extendPeriod > 0
    const isDelayed =
      (investment.latestPaymentDate &&
        new Date(investment.latestPaymentDate).getTime() <
          new Date().getTime()) ||
      false

    return isDelayed || isExtended
  }

  return false
}
